<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import Sidebar from '@/components/Sidebar.vue';
import { Bars3Icon } from '@heroicons/vue/24/outline';
import { useUserDataStore } from '@/stores/userDataStore';

const router = useRouter();
const authStore = useAuthStore();
const isMobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
};

const userDataStore = useUserDataStore();
</script>

<template>
  <div class="min-h-screen overflow-hidden bg-gray-50">
   <div class="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-gray-200 px-4 h-16 flex justify-between">
    
    <div class="flex gap-3 h-full">
        
        <img 
            src="@/assets/img/ram-logo.png" 
            alt="SBSA" 
            class="h-11 w-auto self-start" 
        />
         
        
        <span class="font-semibold text-gray-800 self-center">
            SBSA Pick Up Point
        </span>
    </div>

    <div class="flex items-center">
        <button 
            @click="toggleMobileMenu"
            class="p-2 rounded-lg hover:bg-gray-100"
        >
            <Bars3Icon class="h-6 w-6 text-gray-600" />
        </button>
    </div>
    
</div>

    <div 
      v-if="isMobileMenuOpen"
      class="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
      @click="closeMobileMenu"
    ></div>

    <Sidebar 
      :is-mobile-open="isMobileMenuOpen"
      @close="closeMobileMenu"
      class="fixed left-0 top-0 h-full z-50"
    />

    <!-- <main class="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
      <div class="p-4 lg:p-6 ">
        <router-view />
      </div>
    </main> -->

   <main class="lg:ml-64 pt-16 lg:pt-0 min-h-screen relative">
  <div class="absolute top-0 right-4 z-50 hidden lg:block" :hidden="isMobileMenuOpen">
    <img
      src="/src/assets/img/ram-logo.png"
      alt="Logo"
      class="h-16 w-auto"
    />
  </div>

  <!-- <div class="p-4 lg:p-6">
    <router-view />
  </div> -->
  <div class="p-4 lg:p-6 min-h-screen">
    
    <div v-if="userDataStore.showLoading" class="flex  flex-col items-center justify-center h-screen">
      <div class="w-10 h-10 border-8 border-ram-red border-t-transparent rounded-full animate-spin"></div>
     
    </div>

    <div v-show="!userDataStore.showLoading">
      <router-view />
    </div>
    
  </div>
</main>
  </div>
</template>
